var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell9 = function SvgBell9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 9 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.937 8.75a.17.17 0 0 1 .121.052.16.16 0 0 1 .04.123C5.998 9.642 5.335 10 4.505 10c-.84 0-1.507-.346-1.598-1.077a.2.2 0 0 1 .007-.066q.011-.03.034-.055a.16.16 0 0 1 .12-.052zM4.501 0c.557 0 .976.414 1.125.893a.44.44 0 0 0 .254.26c.852.33 1.888 1.009 1.888 2.917 0 2.083.463 2.401 1.12 3.157.27.312.023.897-.45.898H.562c-.475 0-.72-.586-.449-.898.656-.756 1.12-1.074 1.12-3.157 0-1.908 1.035-2.585 1.888-2.916a.46.46 0 0 0 .255-.261C3.524.413 3.943 0 4.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgBell9;